var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1FFFF"
    },
    d: "M38,182.11V409h436V182.11H38z M204.9,354.56v-118l102.2,59L204.9,354.56z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#304FFE"
    },
    d: "M0,65v382h512V65H0z M496,431H16V160.11h480V431z M16,144.11V81h480v63.11H16z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 101.56,
    style: {
      fill: "#304FFE"
    },
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.51,
    y: 101.56,
    style: {
      fill: "#304FFE"
    },
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.02,
    y: 101.56,
    style: {
      fill: "#304FFE"
    },
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#304FFE"
    },
    d: "M196.9,222.7v145.71l126.2-72.85L196.9,222.7z M212.9,250.41l78.2,45.15l-78.2,45.14L212.9,250.41 L212.9,250.41z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a766b8d35bd88b3eae06177a4c8ec122.svg";
export { ForwardRef as ReactComponent };